import { getStoredAccessToken, getStoredRefreshToken, hasStoredAccessToken, isOtpVerified } from 'pages/Auth/utils';

const useAuthSession = () => ({
  accessToken: getStoredAccessToken(),
  hasSession: hasStoredAccessToken() && Boolean(getStoredRefreshToken()),
  isOtpVerified: isOtpVerified(),
  refreshToken: getStoredRefreshToken(),
});

export default useAuthSession;
